export const listItem = {
  paddingLeft: 0,
  marginTop: "-1px",
  borderTop: "1px solid lightgrey",
  borderBottom: "1px solid lightgrey",
};
